import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../shared/modals';
import { useStore } from '../../shared/store';
import { useDrawer } from '../../shared/drawer';
import { Table } from "../../elements/table";
import { PageBody } from '../../elements/page-body';
import { RenderFilters } from '../../elements/render-filters/render-filters';
import { DetectedRefuelingsFilter } from './detected-refuelings-filter';
import { useHttpClient } from '../../shared/http-client';
import { Map } from '../../elements/map';

export const DetectedRefuelings = () => {
    const { t } = useTranslation();
    const { open, close } = useModal();
    const { open:openDrawer, close: closeDrawer } = useDrawer();
    const { api, state } = useHttpClient();
    const { get, set } = useStore();
    
    const filtrosGuardados = get('repostaje-filtroVehiculos') || {};
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>(filtrosGuardados);
    const [query, setQuery] = useState<any>(new URLSearchParams(filtrosGuardados));
    const [vehicles, setVehicles] = useState<any[]>([]);
    const [showingMap, setShowingMap] = useState<boolean>(true);

    useEffect(() => {
        api('/fleet/vehicles/', 'GET');
    }, []);



    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleFilters = () => {
        openDrawer('common.filter.title', <DetectedRefuelingsFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const doFilter = (filters: any) => {
        set('repostaje-filtroVehiculos', filters);
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        closeDrawer();
    };

    const showMap = (item: any) => {
        if (item.lat && item.lon) {
            const MapWrapper = () => (
                <div className='w-full h-96 flex flex-col'>
                    <h3 className="text-lg leading-6 font-medium text-gray-900">{t('common.label.map-location')}</h3>
                    <div className="mt-2 flex-grow">
                        <Map longitude={item.lon} latitude={item.lat} />
                    </div>
                    <div className='text-[13px] pt-2'>{item.address}</div>
                </div>
            );

            open('custom', { title: '' }, <MapWrapper />);
        }
    };

    useEffect(() => {
        if (state.data && state.path.includes('vehicles')) {
            if (Array.isArray(state.data.results)) {
                setVehicles(state.data.results);
            }
        }
    }, [state]);



    return (
        <PageBody
            title={'common.form-label.repostajes-detectados'}
            filterAction={handleFilters}
            filters={filters}
        >

            <>
                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} vehicles={vehicles} />
                ) : (
                    ''
                )}

                <Table
                    path="/fleet/detected-refuelings/"
                    deletePath="/fleet/detected-refuelings/"
                    callBeforeDrawerClosed={handleClose}
                    withPagination
                    noEdit
                    onShow={showMap}
                    onShowCondition={(item: any) => item.lat && item.lon}
                    query={query}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'vehicle',
                            subKey: 'plate',
                            label: 'common.label.vehiculo'
                        },
                        {
                            key: 'timestamp',
                            type: 'datetime',
                            label: 'common.label.fecha-hora',
                        },
                        {
                            key: 'fuel_level_before',
                            label: 'common.form-label.nivel-combustible-antes',
                            type: 'decimal',
                            suffix: 'L'
                        },
                        {
                            key: 'fuel_level_after',
                            label: 'common.form-label.nivel-combustible-despues',
                            type: 'decimal',
                            suffix: 'L'
                        },
                        {
                            key: 'fuel_quantity',
                            label: 'common.form-label.cantidad-combustible-repostado',
                            type: 'decimal',
                            suffix: 'L'
                        },
                        {
                            key: 'address',
                            label: 'common.form-label.address',
                            className: 'max-w-xs whitespace-normal break-words'
                        },
                    ]}
                />

            </>
        </PageBody>
    );
};